import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Znak marki Księgowskaz — logo poziome (sygnet + nazwa) z dopiskiem modułu „Księgowość".
 *
 * Geometria i kolory pochodzą 1:1 z paczki marki
 * (`svg/ksiegowskaz-logo-poziom-kolor.svg`, siatka 22 × 22 modułów).
 * Wersja podstawowa (kolor) na jasnym tle, negatyw na ciemnym — księga znaku
 * zabrania używania wersji podstawowej na Graficie leśnym.
 * Nie dokrawamy pliku: sygnet ma wbudowany margines 2x u góry i u dołu.
 */
@Component({
  selector: 'app-brand-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg class="brand__logo" viewBox="0 0 109.73 22" aria-hidden="true" focusable="false">
      <path class="brand__mark" d="M0 2H11L15 4L11 6H0Z"></path>
      <path class="brand__mark brand__mark--accent" d="M0 9H18L22 11L18 13H0Z"></path>
      <path class="brand__mark" d="M0 16H7L11 18L7 20H0Z"></path>
      <text class="brand__word" x="28" y="15.851" font-size="13.86" letter-spacing="-0.3604">
        Księgowskaz
      </text>
    </svg>
    <span class="brand__module">Księgowość</span>
  `,
  host: {
    class: 'app-brand',
    role: 'img',
    'aria-label': 'Księgowskaz Księgowość',
    '[class.app-brand--lg]': "size() === 'lg'",
  },
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
      }
      /* 132 px to minimalna szerokość logo poziomego z księgi znaku. */
      .brand__logo {
        flex: 0 0 auto;
        width: 132px;
        height: auto;
        --brand-mark: #1d4a3a;
        --brand-mark-accent: #4e9b76;
        --brand-word: #10231b;
      }
      /* Wersja negatyw — wymagana na ciemnym tle. */
      :host-context(html[data-theme='dark']) .brand__logo {
        --brand-mark: #f4f6f3;
        --brand-mark-accent: #6fbf95;
        --brand-word: #f4f6f3;
      }
      .brand__mark {
        fill: var(--brand-mark);
      }
      .brand__mark--accent {
        fill: var(--brand-mark-accent);
      }
      .brand__word {
        fill: var(--brand-word);
        font-family: 'Space Grotesk', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-weight: 600;
      }
      .brand__module {
        font-family: var(--font-mono);
        font-weight: 500;
        font-size: 0.8125rem;
        letter-spacing: 0.06em;
        color: var(--primary-text);
      }
      :host(.app-brand--lg) .brand__logo {
        width: 168px;
      }
      :host(.app-brand--lg) .brand__module {
        font-size: 0.9375rem;
      }
    `,
  ],
})
export class BrandLogo {
  /** `lg` — ekran logowania; `md` — pasek górny. */
  readonly size = input<'md' | 'lg'>('md');
}
